import React, { useState } from 'react';
import { Button } from '../ui/button';
import { Mail } from 'lucide-react';
import CustomModal from '../ui/CustomModal';

const EmailStep = ({ data, updateData, onNext }) => {
  const [email, setEmail] = useState(data.email || '');
  const [phone, setPhone] = useState(data.phone || '');
  const [contactMethod, setContactMethod] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const phoneRegex = /^[0-9]{10}$/;

  const handleContinue = () => {    
    if (contactMethod === 'email' && emailRegex.test(email)) {
        updateData('email', email);
        onNext();
    } else if (contactMethod === 'phone' && phoneRegex.test(phone)) {
        updateData('email', `91${phone}`);
        onNext();
    } else {
      setIsModalOpen(true);
    }
  };

  return (
    <div className="text-center flex flex-col items-center justify-center min-h-[70vh] px-6">
      {/* Animated cards */}
      <div className="relative mb-8">
        <div className="flex gap-4 transform -rotate-12">
          <div className="w-24 h-32 rounded-2xl bg-gradient-to-br from-[#F1B428]/30 to-[#1A1A1A] border border-white/10 flex items-center justify-center text-3xl shadow-xl">
            😊
          </div>
          <div className="w-24 h-32 rounded-2xl bg-gradient-to-br from-[#1A1A1A] to-[#2A2A2A] border border-[#F1B428]/30 flex items-center justify-center text-3xl shadow-xl transform rotate-6">
            🔞
          </div>
          <div className="w-24 h-32 rounded-2xl bg-gradient-to-br from-[#2A2A2A] to-[#1A1A1A] border border-white/10 flex items-center justify-center text-3xl shadow-xl">
            💧
          </div>
        </div>
      </div>

      <h1 className="text-white text-2xl md:text-3xl font-bold mb-4">
        Your AI girlfriend
        <br />
        is almost ready 💗
      </h1>

      <p className="text-white/70 text-sm md:text-base mb-6 max-w-md">
        Enter your phone number or email to continue.
        <br />
        Create your account to save your preferences and start chatting instantly.
      </p>

      {/* Phone input */}
      <div className="w-full max-w-md mb-4">
        <div className="relative">
          <span className="absolute left-6 top-1/2 transform -translate-y-1/2 text-black font-medium">+91</span>
          <input
            type="tel"
            value={phone}
            onChange={(e) => {
              const value = e.target.value;
              setPhone(value);
              if (value) {
                setContactMethod('phone');
                setEmail('');
              } else {
                setContactMethod('');
              }
            }}
            placeholder="Type your phone number"
            disabled={contactMethod === 'email'}
            className={`w-full ${contactMethod === 'email' ? 'bg-[#F1B428]/50' : 'bg-[#F1B428]'} text-black placeholder-black/50 rounded-full px-14 py-4 text-base focus:outline-none focus:ring-2 focus:ring-[#F1B428] font-medium`}
          />
        </div>
      </div>

      {/* <div className="w-full max-w-md mb-4 text-center">
        <span className="text-white/50 text-sm">OR</span>
      </div>

      <div className="w-full max-w-md mb-6">
        <div className="relative">
          <Mail className="absolute left-4 top-1/2 transform -translate-y-1/2 text-black" size={20} />
          <input
            type="email"
            value={email}
            onChange={(e) => {
              const value = e.target.value;
              setEmail(value);
              if (value) {
                setContactMethod('email');
                setPhone('');
              } else {
                setContactMethod('');
              }
            }}
            disabled={contactMethod === 'phone'}
            placeholder="Type your email"
            className={`w-full ${contactMethod === 'phone' ? 'bg-[#F1B428]/50' : 'bg-[#F1B428]'} text-black placeholder-black/50 rounded-full px-12 py-4 text-base focus:outline-none focus:ring-2 focus:ring-[#F1B428] font-medium`}
          />
        </div>
      </div> */}

      <p className="text-white/50 text-xs mb-8 max-w-sm">
        We need your phone number to save your preferences and get you chatting right way.
      </p>

      <Button
        onClick={handleContinue}
        disabled={!(
          (contactMethod === 'email' && emailRegex.test(email)) ||
          (contactMethod === 'phone' && phoneRegex.test(phone))
        )}
        className={`w-full max-w-md font-bold text-lg py-6 rounded-full transition-all duration-300 ${
          (contactMethod === 'email' && emailRegex.test(email)) ||
          (contactMethod === 'phone' && phoneRegex.test(phone))
            ? 'bg-[#F1B428] hover:bg-[#D9A022] text-black shadow-lg shadow-[#F1B428]/30 hover:scale-105'
            : 'bg-white/10 text-white/30 border border-white/10 cursor-not-allowed'
        }`}
      >
        Continue
      </Button>

      <CustomModal
        isOpen={false}
        onClose={() => setIsModalOpen(false)}
        onConfirm={handleContinue}
        message="Please use the same phone number/email during signup, to receive your AI girlfriend/credits on the same account."
      />
    </div>
  );
};

export default EmailStep;
